export const downloadFile = (fileData, filename) => {
  // remove quotation marks otherwise chrome appends underscores at the start and end of the filename if it has spaces
  // TODO - test other browsers
  filename = filename.replace(/["]/g, '')

  // ie11 doesn't support the download attribute on the a tag so save this way
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(fileData, filename)
  } else {
    // create a url representing the file we've downloaded from ther server
    /// https://developer.mozilla.org/en-US/docs/Web/API/File/Using_files_from_web_applications#Using_object_URLs
    const url = window.URL.createObjectURL(fileData);

    // create a link element, set it to be a download link, set url to be the Blob that has been downloaded, force click
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', filename)
    link.click()

    // release url created from file to free up memory
    window.URL.revokeObjectURL(url)
  }
}


// WEBPACK FOOTER //
// ./src/js/file.js